export default {
  name: { id: 'name' },
  site: { id: 'site' },
  visibleInUi: { id: 'visible_in_ui' },
  saveInfo: { id: 'save_info' },
  units: { id: 'units' },
  unitGroupList: { id: 'unit_group_list' },
  unitGroupInfo: { id: 'unit_group_info' },
  createUnitGroup: { id: 'create_unit_group' },
  editUnitGroup: { id: 'edit_unit_group' },
  deleteUnitGroup: { id: 'delete_unit_group' },
  deleteUnitGroupMessage: { id: 'delete_unit_group_message' },
  dateUpdated: { id: 'date_updated' },
}
